import SmartLockDetails from './SmartLockDetails';

export default SmartLockDetails;
